import { render, staticRenderFns } from "./AmplifyCard.vue?vue&type=template&id=35b4dac9&scoped=true&"
import script from "./AmplifyCard.vue?vue&type=script&lang=js&"
export * from "./AmplifyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b4dac9",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Cam\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b4dac9')) {
      api.createRecord('35b4dac9', component.options)
    } else {
      api.reload('35b4dac9', component.options)
    }
    module.hot.accept("./AmplifyCard.vue?vue&type=template&id=35b4dac9&scoped=true&", function () {
      api.rerender('35b4dac9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/amplify/AmplifyCard.vue"
export default component.exports